export const scale_d = (value_px_at_1920: number): string =>
  `calc(100vw * (${value_px_at_1920} / 1920))`;

// export const scale_d = (value_px_at_1920: string): string =>
//   `calc(100vw * (${value_px_at_1920} / 1920))`;

export const scale_m = (value_px_at_390: number): string =>
  `calc(100vw * (${value_px_at_390} / 390))`;